import React, { useState } from "react";
import { TabContext, TabList } from "@mui/lab";
import Tab from "@mui/material/Tab";
import TabPanel from "@mui/lab/TabPanel";
import { Box } from "@mui/system";
import Allergies from "./Allergies";
import ChronicDiseases from "./ChronicDiseases";
import CriticNotes from "./CriticNotes";
import { Typography } from "@mui/material";
import PatientBody from "./PatientBody";

const PatientFill = () => {
  const [selectedTab, setSelectedTab] = useState("0");

  const handleChangeTab = (event: React.SyntheticEvent, newValue: string) => {
    setSelectedTab(newValue);
  };
  return (
    <>
      <Typography variant="h5" gutterBottom sx={{ p: 0 }}>
        Patient Info
      </Typography>
      <Box sx={{ width: "100%" }}>
        <Box sx={{ bgcolor: "#fff", p: 4 }}>
          <TabContext value={selectedTab}>
            <Box
              sx={{
                borderBottom: 1,
                borderColor: "divider",
                display: "flex",
                justifyContent: "center",
              }}
              width="100%"
            >
              <TabList
                onChange={handleChangeTab}
                textColor="secondary"
                indicatorColor="secondary"
                variant="scrollable"
                scrollButtons="auto"
                allowScrollButtonsMobile
              >
                <Tab label="General" value="0" />
                <Tab label="Allergies" value="1" />
                <Tab label="Chronic Diseases" value="2" />
                <Tab label="Critic Notes" value="3" />
              </TabList>
            </Box>
            <TabPanel value="0">
              <PatientBody />
            </TabPanel>
            <TabPanel value="1">
              <Allergies />
            </TabPanel>
            <TabPanel value="2">
              <ChronicDiseases />
            </TabPanel>
            <TabPanel value="3">
              <CriticNotes />
            </TabPanel>
          </TabContext>
        </Box>
      </Box>
    </>
  );
};

export default PatientFill;
